export default "__VITE_ASSET__7MpKoPWY__"